import React from "react";
import { ReactComponent as ANGULAR } from "../img/skill_icons/angular.svg";

export const Angular = ({ className }) => {
  return <ANGULAR title="angular" className={className} />;
};
